import { ContextStatus } from "@leedpulse-monorepo/enums";

export const INPUT_EMPTY_ERROR = 'Le champ ne doit pas être vide';

export const handleInputError = (inputValue: string | undefined, status: ContextStatus) => {
    return status === ContextStatus.ERROR &&
        inputValue === '' ? 'error' : 'success';
};

export const handleErrorInputMessage = (inputValue: string | undefined, status: ContextStatus) => {
    if (status === ContextStatus.ERROR && inputValue === '') {
        return INPUT_EMPTY_ERROR;
    }
    return '';
};

export const formatErrorMessage = (message: string) => {
    return message.replace(/\p{Emoji_Presentation}|\p{Extended_Pictographic}/gu, '');
}